import { Body1 } from "melodies-source/Text";
import React from "react";
import styled from "styled-components";
import { Loader as LoaderComponent } from "./Loader";

export const Loader = LoaderComponent;

interface Props {
  color: string;
  icon?: React.ReactNode;
  text?: string | React.ReactNode;
  className?: string;
}

export const CircularGradientLoader: React.FC<Props> = ({
  color,
  icon,
  text,
  className,
}) => {
  return (
    <Container className={className}>
      <LoaderContainer>
        <Loader color={color} />
        {icon && <IconContainer>{icon}</IconContainer>}
      </LoaderContainer>
      {text && (typeof text === "string" ? <Body1>{text}</Body1> : text)}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

const LoaderContainer = styled.div`
  position: relative;
`;

const IconContainer = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;
